import { Impuesto } from "./Impuesto";

import { EmissionPoint } from './EmissionPoint';
import { SubjectCustomer } from './SubjectCustomer';

import { PaymentMethod } from 'src/app/modelo/PaymentMethod';

export class Retencion {
    
    id: number;
    uuid: string;
    description: string;

    emissionOn: Date;
    
    //SRI
    estab: string;
    ptoEmi: string;
    emissionPoint: EmissionPoint;
    secuencial: string;
    enviarSRI: boolean;
    accionSRI: string;
    claveAcceso: string;
    internalStatus: string;
    
    customerId: number;
    customerEmail: string;
    direccion: string;
   
    fechaDeEmision: Date;
    tipoDocumentoIdentidad: string;
    customerCode: string;
    customerMobileNumber: string;
    
    destinatarios: any[] = [];
    
    subjectCustomer: SubjectCustomer;
    details: RetencionDetalle[] = [];
    
     /**
     * Para almacenar en formato json los campos adicionales
     */
    jsonCamposAdicionales:string;
    /**
     * Para almacenar en formato json los destinatarios
     */
    jsonDestinatarios:string;
}

export class RetencionDetalle {
    
    indice:number;
        
    id:number;
    retencionId: number;

    tipoDocumentoSustento:string;
    estabDocumentoSustento:string;
    ptoEmiDocumentoSustento:string;
    numeroDocumentoSustento:string;
    
    fechaEmisionDocumentoSustento:Date;
    
    codigoTipoImpuesto:string;
    codigoTipoRetencion:string;
    porcentaRetencion: number;
    
    baseImponible: number;
    montoRetenido: number;
    
    
    //UX 
    tipoImpuesto:PaymentMethod;
    tipoComprobante:PaymentMethod;
    retencion:PaymentMethod;
}